import { ROUTER } from '@/shared/config'
import React from 'react'
import { defineEntry, toPublicRoute } from './routeEntry'

const publicPages = [
  defineEntry({
    path: ROUTER.HOME,
    page: React.lazy(() => import('@/pages/home')),
  }),
  defineEntry({
    path: ROUTER.LOGIN,
    page: React.lazy(() => import('@/features/IndentityLogin/pages/LoginPage')),
  }),
  defineEntry({
    path: ROUTER.DANG_NHAP_OTP,
    page: React.lazy(() => import('@/features/IndentityLogin/pages/OtpLoginPage')),
  }),
  defineEntry({
    path: ROUTER.DAT_MAT_KHAU,
    page: React.lazy(() => import('@/features/set-password/pages/SetPasswordPage')),
  }),
  defineEntry({
    path: ROUTER.TRA_CUU,
    page: React.lazy(() => import('@/features/public-lookup')),
  }),
]

export const publicRoutes = publicPages.map(toPublicRoute)
